import type { ChatConversation, ChatMessage } from './types'

export type ChatHistory = {
  messages: ChatMessage[]
  cursor: string | null
}

export function mergeMessages(earlier: ChatMessage[], latest: ChatMessage[]) {
  const byId = new Map(
    [...earlier, ...latest].map(message => [message.id, message])
  )
  return [...byId.values()].sort(
    (left, right) =>
      left.createdAtUtc.localeCompare(right.createdAtUtc) ||
      left.id.localeCompare(right.id)
  )
}

export function receiveLatestPage(
  history: ChatHistory,
  page: Pick<ChatConversation, 'messages' | 'olderCursor'>
): ChatHistory {
  const known = new Set(history.messages.map(message => message.id))
  const overlaps = page.messages.some(message => known.has(message.id))
  // A long absence can replace the entire latest page. Start paging from that
  // new boundary so neither the display nor a transcript silently skips a gap.
  const cursor = !page.olderCursor
    ? null
    : overlaps
      ? history.cursor
      : page.olderCursor
  return {
    messages: mergeMessages(history.messages, page.messages),
    cursor,
  }
}
